// extracted by mini-css-extract-plugin
export var byText = "index-module--byText--8qrVa";
export var container = "index-module--container--UhQIM";
export var description = "index-module--description--W5uED";
export var designation = "index-module--designation--ZFtju";
export var imageBox = "index-module--imageBox--M5zh9";
export var name = "index-module--name--MCk6Q";
export var textBox = "index-module--textBox--9bHqM";